import styled from 'styled-components';
import { Table } from 'edenred-ui';

export const HeaderButton = styled.div`
  cursor: pointer;
`;

export const Summary = styled.div`
  margin: 12px 18px;
  display: flex;
  justify-content: space-between;

  font-size: ${props => props.theme.fontSize};
  font-weight: ${props => props.theme.fontSemiBold};
`;

export const NoWrapHeader = styled(Table.Cell)`
  text-wrap: nowrap;
  text-align: right;
`;

export const BreakWordCell = styled(Table.Cell)`
  word-break: break-word;
  min-width: 300px;
`;
